import React, { createContext, useContext, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./PersonnelsUIHelpers";

const PersonnelsUIContext = createContext();

export function usePersonnelsUIContext() {
  return useContext(PersonnelsUIContext);
}

export const PersonnelsUIConsumer = PersonnelsUIContext.Consumer;

export function PersonnelsUIProvider({ personnelsUIEvents, children }) {
  const { user } = useSelector(state => state.auth);
  initialFilter.term = user.currentActiveTerm; // Mevcut Aktif Dönem Atanıyor
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);
  
  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    openNewPersonnelPage: personnelsUIEvents.openNewPersonnelPage,
    openEditPersonnelPage: personnelsUIEvents.openEditPersonnelPage
  };

  return (
    <PersonnelsUIContext.Provider value={value}>
      {children}
    </PersonnelsUIContext.Provider>
  );
}